import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import CMS from './CMS';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cms" element={<CMS />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;